// frontend/controllers/clipboard_controller.js
import { Controller } from "@hotwired/stimulus"

// Copies the text value to the clipboard on click and briefly swaps the
// copy icon for a check mark as confirmation.
export default class extends Controller {
  static values = { text: String }
  static targets = ["copyIcon", "doneIcon"]

  async copy() {
    await navigator.clipboard.writeText(this.textValue)
    this.copyIconTarget.classList.add("hidden")
    this.doneIconTarget.classList.remove("hidden")
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      this.doneIconTarget.classList.add("hidden")
      this.copyIconTarget.classList.remove("hidden")
    }, 1500)
  }

  disconnect() {
    clearTimeout(this.timeout)
  }
}
